import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { includes, map } from "lodash";

import Emitter from "../../utils/Emitter";

import { getCountryList } from "../../actions/defaultDataAction";

import { default as ReactSelect, components } from "react-select";

import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import DropDown from "../../components/DropDown";
import InputField from "../../components/InputField";
import DateRangePickerField from '../../components/DateRangePickerField';
import { format } from 'date-fns';
import ToolipsCustom from "../../components/ToolipsCustom";

const AllSendInquiriesFilter = (props) => {
  const findByOptions = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Supplier",
      value: "Supplier",
    },
    {
      label: "Logistic Partner",
      value: "Logistic_Partner",
    },
  ];

  const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{ display: "flex", alignItems: "center" }}
      className={isSelected ? "div-item-selected" : "div-item-unselected"}
    >
      {isSelected && (
        <div className={` item-selected `}>
          <label style={{ marginLeft: "8px" }}>{label}</label>
        </div>
      )}
      {!isSelected && (
        <div className={` item-selected2 `}>
          <label style={{ marginLeft: "8px" }}>{label}</label>
        </div>
      )}
    </div>
  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      "&:hover": {},
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#4c9bdb", // Background of the selected multi-value items
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#fff", // Color of the text inside the multi-value
      fontSize: "20px",
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      color: "#df0024", // Remove button color
      ":hover": {
        backgroundColor: "#df0024", // Background color on hover for the remove button
      },
    }),
  };

  const [findByOptionVal, setFindByOptionVal] = useState(findByOptions[0]);
  const [countryList, setCountryList] = useState([]);

  const [country, setSelectedCountry] = useState([]);
  // const [isFilteredData, setFilterData] = useState(false);
  const [searchedTxt, setSearchedTxt] = useState(null);
  const initialFilterRef = useRef(true);
  const [dateRange, setDateRange] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [placehoderTxt, setPlaceHoderTxt] = useState("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry/Commodity");
  const today = new Date();

  const handleFindByChange = (val) => {
    setFindByOptionVal(val);
    if (val) {
      let filterType = val.value;
      if (filterType === "Supplier") {
        setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry");
      } else if (filterType === "Logistic_Partner") {
        setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Inquiry ID, Commodity");
      } else {
        setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry/Commodity");
      }
    }
  };

  const handleInputChange = async (e) => {
    setSearchedTxt(e.target.value);
  };

  const handleCountryChange = (val) => {
    setSelectedCountry(val);
  };

  const handleChange = (val) => {
    setDateRange(val);
    if (val) {
      const [fromDate, toDate] = val;

      const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
      setStartDate(formattedFrom);
      setEndDate(formattedTo);

    } else {
      setStartDate("");
      setEndDate("");
    }

  }

  const filterInquiries = () => {
    const filterObj = {};
    filterObj.filter_val = searchedTxt;
    filterObj.findWhom = findByOptionVal.value;
    filterObj.selected_country = map(country, "label");
    filterObj.startDate = startDate;
    filterObj.endDate = endDate;
    // setFilterData(true);
    Emitter.emit("SET_FILTER_INQUIRIES", filterObj);

    setTimeout(() => {
      Emitter.emit("FILTER_INQUIRIES", filterObj);
    }, 1000);
  };

  const resetFilter = () => {
    const filterObj = {};

    filterObj.findWhom = findByOptions[0].value;
    setFindByOptionVal(findByOptions[0]);

    setSelectedCountry([]);
    setSearchedTxt("");

    setDateRange(null);
    setStartDate("");
    setEndDate("");

    setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry/Commodity");

    filterObj.filter_val = "";

    filterObj.selected_country = [];

    filterObj.startDate = "";
    filterObj.endDate = "";

    Emitter.emit("SET_FILTER_INQUIRIES", filterObj);

    setTimeout(() => {
      Emitter.emit("FILTER_INQUIRIES", filterObj);
    }, 1000);
  };

  const fetchFilterSelection = async () => {
    const result = await Promise.allSettled([props.getCountryList()]);

    result.forEach((res, indx) => {
      let dataList = [];
      let data = [];
      if (res.status === "fulfilled") {
        if (includes([0, 1, 3], indx)) {
          data = res.value;
        } else if (includes([2], indx)) {
          data = res.value.data;
        }

        if (indx === 0) {
          dataList = data.map((v) => {
            return {
              label: v.name,
              value: v.id,
            };
          });
          setCountryList(dataList);
        }
      } else {
        console.log(
          "Something Went Wrong while fetching index ",
          indx,
          "!! ",
          res.reason
        );
      }
    });
  };

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      background: "#d4eefa",
      borderRadius: "4px",
      fontFamily: "Open Sans",
      fontSize: "11px",
      padding: "3px",
      order: 99,
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 3;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  useEffect(() => {
    if (initialFilterRef.current === true) {
      fetchFilterSelection();
      initialFilterRef.current = false;
    }
  }, [initialFilterRef]);


  const defaultCalendarValue = [
    new Date(today.getFullYear(), today.getMonth() - 1, 1),
    new Date(today.getFullYear(), today.getMonth(), 1)
  ];

  return (
    <div className="bg-white shadow rounded mb-4">
      <div className="buyer-suplier-search-section member-filter">
        <div className="buyer-suplier-section-child all">
          <DropDown
            placeholder="Select.."
            options={findByOptions}
            value={findByOptionVal}
            onChange={handleFindByChange}
            menuPlacement="bottom"
          />
        </div>

        <div className="buyer-suplier-section-child country">
          <ReactSelect
            options={countryList}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option: CustomOption,
              IndicatorSeparator: () => null,
              MultiValue,
            }}
            onChange={handleCountryChange}
            value={country}
            removeSelected={false}
            styles={customStyles}
            placeholder="Select country"
            className="member-filter-container"
            classNamePrefix="member-filter-select"
            noOptionsMessage={() => "No Country Found"}
          />
        </div>

        <div className="buyer-suplier-section-child date-range">

          <DateRangePickerField
            value={dateRange}
            onChange={handleChange}
            defaultCalendarValue={defaultCalendarValue}
          />

        </div>

        <div className="buyer-suplier-section-child search">

          <div className="d-flex align-items-center w-100">

            <InputField
              type="text"
              id="filter-text-box"
              placeholder="Search Keywords"
              className="w-25"
              onChange={handleInputChange}
              value={searchedTxt}
              autoComplete="off"
            ></InputField>
            <ToolipsCustom
              title={"?"}
              subtitle={placehoderTxt}
            >
            </ToolipsCustom>


          </div>


        </div>

        <div className="filter-search-btn search-btn">
          <ButtonAdminpanel type="button" onClick={filterInquiries}>
            {" "}
            <i className="fa-solid fa-magnifying-glass text-white"></i> Search{" "}
          </ButtonAdminpanel>

          <button
            type="button"
            className=" btn filter-reset-btn mx-2"
            onClick={resetFilter}
          >
            <svg
              viewBox="0 0 21 21"
              xmlns="http://www.w3.org/2000/svg"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="#000000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="matrix(0 1 1 0 2.5 2.5)"
                >
                  {" "}
                  <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path>{" "}
                  <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path>{" "}
                </g>{" "}
              </g>
            </svg>
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: () => dispatch(getCountryList()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(AllSendInquiriesFilter));
